#import "../fragments/queued-email-fragment.graphql"

query GetQueuedEmail($queuedEmailId: ID!) {
    queuedEmail(queuedEmailId: $queuedEmailId) {
        ...QueuedEmail
    }
}
